import React, { useContext } from "react";
import _ from "lodash";
import { Row, Col } from "react-bootstrap";
import { Grid, Select, MenuItem, Input, Snackbar } from "@material-ui/core";
import { AdminContext } from "../../context/DeliveryContext";
import DataGriddle from "./DataGriddle";
import MuiAlert from "@material-ui/lab/Alert";
import "../../styles/deliverylist.scss";
import {StyledDarkBlueButton} from "../../styles/BootstrapStyles";
import { BannerListView } from "./BannerListView";
import { BannerContext } from "../../context/BannerContext";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const ListView = () => {
  const {
    lists,
    selectedList,
    newItem,
    itemList,
    _setSelectedList,
    _setNewItem,
    onAddItem,
    message,
    _setMessage,
  } = useContext(AdminContext);
  const { bannerMessage , _setBannerMessage } = useContext(BannerContext);
  const snackbarMessage = message || bannerMessage;
  const snackbarSeverity = snackbarMessage === "Network error" ? "error" : "success";
  return !_.isEmpty(lists) ? (
    <>
      <Grid
        item
        xs={12}
        className="mt-5">
        <Row id={"Summary_detail_view"} className="m-0 p-0">
          <Col
            xs={5}
            className="listColumn"
            id={"list_column_left"}>
              <Row className="mx-0 mt-0 mb-4 p-0 w-100">
                <label className="title">
                  List Name
                </label>
                <Select
                  value={selectedList}
                  className="listInput"
                  displayEmpty
                  disableUnderline={true}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  classes={{
                    disabled: "formSelectDisabled",
                  }}
                  onChange={(e) => {
                    _setSelectedList(_.get(e, "target.value", ""));
                  }}>
                  {_.map(_.keys(lists), (list, index) => {
                    return (
                      <MenuItem className="dropdownSelect" key={"listName" + index} value={list}>
                        {list}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Row>
              <Row className="mx-0 mt-0 mb-4 p-0 w-100">
                <label className="title">
                  Total Items
                </label>
                <div className="totalItems">
                  {_.size(itemList)}
                </div>
              </Row>
              <Row className="m-0 p-0 w-100">
                <Input
                  type="text"
                  placeholder="Item name"
                  className="listInput"
                  disableUnderline={true}
                  value={newItem}
                  onChange={(e) => {
                    _setNewItem(e.target.value);
                  }}
                  // onBlur={trim}
                  onBlur={(e) => {
                    _setNewItem(_.trim(newItem));
                  }}
                />
                <StyledDarkBlueButton
                    className="mx-0 mt-2"
                    disabled={_.size(newItem) === 0}
                    onClick={onAddItem}>
                  Add an Item
                </StyledDarkBlueButton>
              </Row>
              <Row className="m-0 p-0 w-100">
                <Col xs={12} className="p-0">
                  <BannerListView />
                </Col>
              </Row>
          </Col>
          <Col
            xs={7}
            id={"list_column_right"}>
            <div>
              <DataGriddle />
            </div>
          </Col>
        </Row>
      </Grid>
      {!_.isEmpty(snackbarMessage) ? (
        <Snackbar
          onClose={(event, reason) => {
            _setMessage("");
            _setBannerMessage("");
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={true}
          autoHideDuration={3000}
        >
          <Alert
            onClose={(event) => {
              _setMessage("");
              _setBannerMessage("");
            }}
            severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      ) : null}
    </>
  ) : null;
};